import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { NgOptimizedImage } from '@angular/common';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FooterComponent } from './components/footer/footer.component';
import { HomeComponent } from './pages/home/home.component';
import { AboutComponent } from './pages/about/about.component';
import { provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { TranslatePipe, provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';

// Pages
import { SearchComponent } from './pages/search/search.component';
import { KeywordResultsComponent } from './pages/search/keyword-results/keyword-results.component';
import { ContactComponent } from './pages/contact/contact.component';
import { AdvancedSearchComponent } from './pages/search/advanced-search/advanced-search.component';
import { SearchResultsComponent } from './pages/search/search-results/search-results.component';

// Services
import { ApiService } from './services/api.service';
import { LegacyUrlService } from './services/legacy-url.service';
import { LegacyUrlInterceptorService } from './services/legacy-url-interceptor.service';
import { AsyncPipe } from '@angular/common';

// Shared Module
import { SharedModule } from './components/shared/shared.module';
import { CachedImageDirective } from './directives/cached-image.directive';
import { VerifyEmailComponent } from './components/verify-email/verify-email.component';

@NgModule({ declarations: [
        AppComponent,
        FooterComponent,
        HomeComponent,
        AboutComponent,
        SearchComponent,
        KeywordResultsComponent,
        ContactComponent,
        CachedImageDirective,
        VerifyEmailComponent,
        AdvancedSearchComponent,
        SearchResultsComponent
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        AppRoutingModule,
        FormsModule,
        ReactiveFormsModule,
        AsyncPipe,
        SharedModule,
        BrowserAnimationsModule,
        NgOptimizedImage,
        TranslatePipe], providers: [
        ApiService,
        provideHttpClient(withXhr(), withInterceptorsFromDi()),
        provideTranslateService({
            loader: provideTranslateHttpLoader({ prefix: './assets/i18n/', suffix: '.json' }),
            fallbackLang: 'tr'
        })
    ] })
export class AppModule { 
  constructor(private legacyUrlInterceptor: LegacyUrlInterceptorService) {
    // Initialize the legacy URL interceptor
  }
}